import React, { useMemo } from 'react'
import PolarAreaChart from '../../Charts/PolarAreaChart'
import LineChart from '../../Charts/LineChart'
import { isEmpty } from 'lodash'
import { formatNumber } from '../../../lib/utils/formatNumber'

type Props = {
  conversions: Array<{
    date: Date
    tag_name: string
    conversions: number
    all_conversions: number
  }>
  isLoading: boolean
  isPreviousData: boolean
}

const SearchConversionMetrics = ({
  conversions,
  isLoading,
  isPreviousData,
}: Props): JSX.Element => {
  const allConversions = useMemo(() => {
    return conversions?.reduce((acc, cur) => {
      const found = acc.find((d) => d.date === cur.date)
      if (found) {
        found.conversions += cur.conversions
      } else {
        acc.push({
          date: cur.date,
          conversions: cur.conversions,
        })
      }
      return acc
    }, [] as Array<{ date: Date; conversions: number }>)
  }, [conversions])
  return (
    <>
      {!isEmpty(conversions) && (
        <div className={'flex grid grid-cols-2 gap-5'}>
          <div className={'min-h-[270px] border-2 rounded-xl'}>
            <div
              className={
                'pt-5 pb-2 px-5 flex justify-between font-bold text-sm text-primary-xiketic'
              }>
              <span>Total Conversions</span>
              <span>
                {formatNumber(
                  allConversions?.reduce((acc, cur) => acc + cur.conversions, 0) ?? 0,
                )}
              </span>
            </div>
            <div className={'h-[270px] p-2'}>
              <LineChart
                data={allConversions}
                gradient={'green-to-lemon-green'}
                yKey={'conversions'}
                isLoading={isLoading}
                isPreviousData={isPreviousData}
                customOptions={{
                  scales: {
                    y: {
                      min: 0,
                      ticks: {
                        stepSize: 1,
                      },
                    },
                  },
                }}
              />
            </div>
          </div>
          <div className={'min-h-[270px] border-2 rounded-xl'}>
            <div
              className={
                'pt-5 pb-2 px-5 flex justify-between font-bold text-sm text-primary-xiketic'
              }>
              <span>Conversion Breakout</span>
            </div>
            <div className={'h-[270px] p-2'}>
              <PolarAreaChart
                data={Object.entries(
                  conversions?.reduce((acc, curr) => {
                    if (!acc[curr.tag_name]) acc[curr.tag_name] = curr.conversions
                    else acc[curr.tag_name] += curr.conversions
                    return acc
                  }, {}),
                ).map(([label, value]) => ({ label, value: Number(value) }))}
                isPreviousData={isPreviousData}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SearchConversionMetrics
